import moment from "moment";

export const filterByDateRange = (requests, dateRange) => {
  if (!dateRange) return requests;

  const [year, q] = dateRange.split("-");
  const quarter = parseInt(q.replace(/q/i, ""), 10);

  const startDate = moment()
    .year(parseInt(year, 10))
    .quarter(quarter)
    .startOf("quarter");
  const endDate = moment()
    .year(parseInt(year, 10))
    .quarter(quarter)
    .endOf("quarter");

  return requests.filter(request => {
    const requestDate = moment(request.created_at);
    return requestDate.isBetween(startDate, endDate, null, "[]");
  });
};

export const filterByAgency = (requests, agencies) => {
  if (!agencies?.length) return requests;

  return requests.filter(request => agencies.includes(request.agency_name));
};
